'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _svgDefineOnce = require('@brandwatch/axiom-utils/dist/svgDefineOnce');

var _svgDefineOnce2 = _interopRequireDefault(_svgDefineOnce);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  return (0, _svgDefineOnce2.default)('\n  <filter id="ax-candytar__filter">\n    <feColorMatrix type="matrix" values="1 0 0 0    -0.27\n                                         0 1 0 0    -0.27\n                                         0 0 1 0    -0.27\n                                         0 0 0 0.55  0" />\n  </filter>\n');
};